import { FC } from "react";
import { useTheme } from "@/mds/themes/theme-context";
import { useThemedCollectionColors } from "@/mds/themes/use-themed-collection-colors";
import { MDSIcon, MDSIconKind, MDSIconProps } from "@/mds/components/icon/icon";

export interface MDSCollectionIconProps extends Omit<MDSIconProps, "kind"> {
  collectionId?: string;
  variant?: "default" | "placeholder";
}

export const MDSCollectionIcon: FC<MDSCollectionIconProps> = ({
  collectionId,
  size = 14,
  boxSize = 16,
  variant = "default",
}) => {
  const { theme } = useTheme();
  const { iconColor } = useThemedCollectionColors(collectionId);
  const collectionBackgroundColor = variant === "placeholder" ? "transparent" : iconColor;

  return (
    <MDSIcon
      boxSize={boxSize}
      size={size}
      kind={MDSIconKind.Collection}
      overrideColor={
        variant === "placeholder" ? theme.colors.icon.primary : collectionBackgroundColor
      }
    />
  );
};
